import request from "@/utils/request"
const host = "/api/voyager"

// 朋友圈评论通知记录已读
export const apiCommentNotifyReadNew = data => {
  return request({
    url: host + "/sns/comment-notify-read",
    method: "post",
    data
  })
}
